import { API_BASE } from '../config/api';

const parse = async (response) => {
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(payload.error || 'Growth service request failed.');
  return payload;
};

const authorization = (token) => ({ Authorization: `Bearer ${token}` });

export const fetchGrowthDashboard = (token, signal) =>
  fetch(`${API_BASE}/api/growth/admin/dashboard`, { headers: authorization(token), signal }).then(parse);

export const fetchGrowthResource = (resource, token, signal) =>
  fetch(`${API_BASE}/api/growth/admin/${encodeURIComponent(resource)}`, { headers: authorization(token), signal }).then(parse);

export const createGrowthResource = (resource, values, token, reason) =>
  fetch(`${API_BASE}/api/growth/admin/${encodeURIComponent(resource)}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...authorization(token), 'x-confirm-growth-change': 'true', 'x-change-reason': reason },
    body: JSON.stringify(values),
  }).then(parse);

export const updateGrowthResource = (resource, id, values, token, reason) =>
  fetch(`${API_BASE}/api/growth/admin/${encodeURIComponent(resource)}/${encodeURIComponent(id)}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...authorization(token), 'x-confirm-growth-change': 'true', 'x-change-reason': reason },
    body: JSON.stringify(values),
  }).then(parse);
